export default __webpack_public_path__ + "static/media/showroom44.ab41beef.webp";